module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10059.69e09c30.jpg";